import { useAxios } from "@vueuse/integrations/useAxios";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";
import http from "@/common/utils/http-common-utils";
import { AnyFn, Fn } from "@vueuse/core";

const BookingNotificationsService = {
  /**
   * 予約通知の一覧を取得する
   *
   * @async
   * @function
   * @memberof BookingNotificationsService
   * @param {Object} params - 取得条件を含むパラメータ（クリニックIDなど）
   * @returns {Promise<AxiosResponse<Object>>} 通知一覧とページネーション情報を含むレスポンス
   */
  fetch: async (params: any) => {
    const { execute } = useAxios(
      `${ApiRouterConstants.API_BOOKING_NOTIFICATIONS}`,
      { method: "GET", params: params },
      http,
      {
        immediate: false,
      }
    );
    return await execute();
  },
  /**
   * 未読通知の件数を取得する
   *
   * @async
   * @function
   * @memberof BookingNotificationsService
   * @param {Object} params - 取得条件を含むパラメータ
   * @returns {Promise<AxiosResponse<Object>>} 未読件数を含むレスポンス
   */
  count: async (params: any) => {
    const { execute } = useAxios(
      `${ApiRouterConstants.API_BOOKING_NOTIFICATIONS}/count`,
      { method: "GET", params: params },
      http,
      {
        immediate: false,
      }
    );
    return await execute();
  },
  /**
   * 予約通知を更新する
   *
   * @async
   * @function
   * @memberof BookingNotificationsService
   * @param {string} id - 更新対象の予約通知ID
   * @param {Object} data - 更新内容を含むデータオブジェクト
   * @returns {Promise<AxiosResponse<Object>>} 更新後の予約通知オブジェクトを含むレスポンス
   */
  update: async (id: string, data: any) => {
    const { execute } = useAxios(
      `${ApiRouterConstants.API_BOOKING_NOTIFICATIONS}/${id}`,
      { method: "PUT", data: data },
      http,
      {
        immediate: false,
      }
    );
    return await execute();
  },
  /**
   * すべての予約通知（予約アラートを除く）を既読に更新する
   *
   * @async
   * @function
   * @memberof BookingNotificationsService
   * @param {Object} params - 取得条件を含むパラメータ（クリニックIDなど）
   * @returns {Promise<AxiosResponse<Object>>} 既読に更新された件数を含むレスポンス
   */
  all_read: async (params: any) => {
    const { execute } = useAxios(
      `${ApiRouterConstants.API_BOOKING_NOTIFICATIONS}/all_read`,
      { method: "PUT", params: params },
      http,
      {
        immediate: false,
      }
    );
    return await execute();
  },
};

export default BookingNotificationsService;
